import { FC, useState } from "react";
import KickImage from 'Reuseables/KickImage';

//Components
import CustomBody from "../../CustomBody/index";
import { CustomButton, CustomerSelectWithSearch, CustomDropzone } from "../../../../Forms";
import AwbOrSelfDropoff from "./AwbOrSelfDropoff";

//Assets
import UploadIcon from "../../../../../images/upload-icon.png";

//Interfaces
import { MainInterface } from "../definitions";

const Main: FC<MainInterface> = ({
  loading,
  isValid,
  photo,
  photoUrl,
  selectedLogistic,
  awbNumber,
  selectedScheduled,
  selectedDate,
  courierList,
  setDropoffScheduled,
  parseTextHandler,
  onChangeLogistic,
  onBack,
  setPhotoHandler,
  onSelectLogistic,
  submitDropoffHandler,
  onChangeAwbNumber,
  deletePhoto
}): JSX.Element => {
  return (
    <CustomBody loading={loading} withBack backAction={onBack}>
      <div className="drop-off-body">
        <p className="header">Drop-off</p>
        <p className="sub-header">Please input your delivery information below</p>

        {/* Photo */}
        {
          photo ?
            <div className={`upload-photo-wrapper selected`}>
              <KickImage className="photo" src={photoUrl} alt="photo" />
              <p onClick={deletePhoto} className="delete-photo">Delete Photo</p>
            </div>
            :
            <CustomDropzone setPhoto={setPhotoHandler} className={`upload-photo-wrapper`}>
              <>
                <KickImage src={UploadIcon} alt="upload image" className="upload-package-photo" />
                <p className="upload-title">Upload your package’s photo here</p>
                <p className="upload-info">Only upload the picture of this specific order</p>
              </>
            </CustomDropzone>
        }


        {/* SELECT LOGISTIC */}
        <CustomerSelectWithSearch
          className="select-logistic"
          title="Logistic"
          value={selectedLogistic.value}
          name="logistic"
          onChange={onChangeLogistic}
          placeholder="Logistic"
          //@ts-ignore
          options={courierList}
          onSelect={onSelectLogistic}
        />

        {/* INPUT AWB | SELECT SHEDULED */}
        <AwbOrSelfDropoff
          selectedLogistic={selectedLogistic}
          awbNumber={awbNumber}
          selectedScheduled={selectedScheduled}
          selectedDate={selectedDate}
          onChangeAwbNumber={onChangeAwbNumber}
          setDropoffScheduled={setDropoffScheduled}
          parseTextHandler={parseTextHandler}
        />

        <CustomButton
          text={"Submit"}
          disabled={isValid}
          onClick={submitDropoffHandler}
        />
      </div>
    </CustomBody>
  )
}

export default Main;